export const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    
    return `${day}/${month}/${year}`;
};

/**
 * Checks if a given string contains Hebrew or Arabic characters.
 * @param {string} text The string to check.
 * @returns {boolean} True if RTL characters are found, false otherwise.
 */
export const isRTLText = (text) => {
  if (typeof text !== 'string' || !text) return false;
  // Regex for Hebrew (\u0590-\u05FF) and Arabic (\u0600-\u06FF) characters
  const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF]/;
  return rtlRegex.test(text);
};